// This middleware sets an auth token on any query or mutation that requires
// one (the "authToken" parameter must be defined as "not null" type). Does not
// intervene if an auth token is already present on the particular operation.

import { getToken } from '@/common/auth';

export default {
  async applyMiddleware({ options }, next) {
    const authToken = await getToken();
    if (authToken) {
      const headers = options.headers || {};
      headers.Authorization = `Bearer ${authToken}`;
      options.headers = headers;
    }
    next();
  },
};



// WEBPACK FOOTER //
// ./api/middlewares/authenticator.js